module.exports = __webpack_public_path__ + "static/media/modalClose.e23ae5f1.svg";